import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function About() {
  const { ref: textRef, isVisible: textVisible } = useScrollAnimation();
  const { ref: imgRef, isVisible: imgVisible } = useScrollAnimation();

  return (
    <section id="meist" className="py-28 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">

          {/* Text */}
          <div
            ref={textRef}
            className={`transition-all duration-700 ${
              textVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <span className="inline-flex items-center gap-2 text-eco-green text-xs md:text-[30px] font-bold uppercase tracking-[0.2em] mb-5">
              <div className="w-6 h-0.5 bg-eco-green" />
              Kes me oleme
            </span>
            <div className="space-y-5 text-gray-600 text-[15px] leading-relaxed">
              <p>
                IISRAL Recycling OÜ pakub praktilisi ja keskkonnasõbralikke lahendusi
                ehitusjäätmete käitlemiseks otse objektil.
              </p>
              <p>
                Meie eesmärk on lihtne — hoida ehitusplatsid puhtad, tööprotsess sujuv
                ning suunata võimalikult palju materjale taaskasutusse.
              </p>
              <p>
                Töötame efektiivselt ja usaldusväärselt, olles partneriks
                ehitusettevõtetele üle Eesti.
              </p>
            </div>

            {/* Key points */}
            <div className="mt-8 space-y-3">
              {[
                { icon: 'ri-shield-check-line', text: 'Vastutustundlik jäätmekäitlemine' },
                { icon: 'ri-recycle-line', text: 'Maksimaalne taaskasutus' },
                { icon: 'ri-leaf-line', text: 'Keskkonnasõbralik lähenemine' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-pale-green text-eco-green flex-shrink-0">
                    <i className={`${item.icon} text-sm`} />
                  </div>
                  <span className="text-gray-700 text-sm font-medium">{item.text}</span>
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-10 pt-10 border-t border-gray-100">
              {[
                { value: '11+', label: 'Jäätmeliiki' },
                { value: '100%', label: 'Vastutustundlikkus' },
                { value: 'Eesti', label: 'Teenindusala' },
              ].map((s) => (
                <div key={s.label}>
                  <div className="text-2xl font-extrabold text-dark-green mb-1">{s.value}</div>
                  <div className="text-xs text-gray-400 font-medium uppercase tracking-wide">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Images */}
          <div
            ref={imgRef}
            className={`grid grid-cols-2 gap-4 transition-all duration-700 delay-200 ${
              imgVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <div className="w-full h-56 rounded-2xl overflow-hidden mt-10">
              <img
                src="https://public.readdy.ai/ai/img_res/2ab676ec6175ce5781fdb9fcb9cb5e90.jpg"
                alt="Sorteeritud ehitusjäätmed"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-full h-72 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20construction%20workers%20orange%20safety%20vests%20hard%20hats%20working%20together%20sorting%20managing%20construction%20materials%20organized%20site%20teamwork%20industrial%20environment%20natural%20daylight%20sustainable%20eco%20friendly%20work%20practices%20warm%20professional%20photography&width=400&height=500&seq=iisral-about-workers-001&orientation=portrait"
                alt="Meie meeskond objektil"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-full h-44 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=close%20up%20construction%20waste%20recycling%20sorting%20different%20materials%20wood%20metal%20plastic%20separate%20color%20coded%20containers%20bins%20industrial%20workplace%20clean%20organized%20system%20natural%20light%20eco%20sustainability%20theme%20professional&width=400&height=280&seq=iisral-about-sort-001&orientation=landscape"
                alt="Jäätmete sorteerimine"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-full h-44 rounded-2xl overflow-hidden bg-dark-green flex flex-col items-center justify-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-leaf-line text-3xl text-eco-green" />
              </div>
              <div className="text-sm font-bold text-white text-center px-3">Roheline mõtteviis</div>
              <div className="text-xs text-white/50 text-center px-4">
                Keskkonnasõbralikud lahendused
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
